import { useState } from "react";
import { Icon } from "@/components/lib";

type SelectProps = {
  options?: { value: string; label: string }[];
  default: { value: string; label: string };
  onChange: (value: string) => void;
  className?: string;
  optionsClassName?: string;
  label?: string;
  loading?: boolean;
};

const SelectInput = (props: SelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(props.default);

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={props.className}
        disabled={props.loading || !props.options}
      >
        <span className="truncate">{selected.label}</span>
        {selected.value ? (
          <span
            onClick={() => {
              setSelected(props.default);
              props.onChange(props.default.value);
            }}
            className="pt-0.5"
          >
            <Icon image="x" />
          </span>
        ) : (
          <Icon image="chevron-down" className="pt-0.5" />
        )}
      </button>
      {isOpen && props.options && (
        <div className={props.optionsClassName}>
          {props.options.map((option) => (
            <div
              key={option.value}
              className="px-4 py-2 hover:bg-gray-700 cursor-pointer truncate"
              onClick={() => {
                setSelected(option);
                setIsOpen(false);
                props.onChange(option.value);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectInput;
